export default "__VITE_ASSET__CfH788hF__"